<template>
    <div :class="messageClasses">
        <div class="message-body html-content">
            <!--<div v-if="hasHtmlBody" v-html="htmlBody"></div>!-->
            <div v-if="contentLoading" style="height: 150px; display: flex;" class="align-items-center">
                <ui-progress-circular
                    :stroke="2"
                    type="indeterminate"
                    style="margin:auto; padding-top: 11rem;"
                    :size="64">
                </ui-progress-circular>
            </div>
            <iframe
                scrolling="no"
                sandbox="allow-same-origin allow-popups"
                v-if="hasHtmlBody"
                ref="htmlContent"
                :style="{ width: contentLoading ? '1px' : '100%', height:  contentLoading ? '1px' : height + 'px', border: '0' }"
            ></iframe>
            <pre style="white-space: pre-wrap; overflow-wrap: normal; margin-bottom: 0; font-family: var(--font-family-sans-serif); font-size: 1rem;" v-else>{{ plainBody }}</pre>
        </div>
        <div class="message-attachments" v-if="hasAttachments">
            <span class="material-icons" style="vertical-align: middle;">attachment</span>
            <a class="message-attachment" v-for="attachment in message.attachments" :href="'/api/inbox/attachments/' + attachment.id + '/download'">
                {{ attachment.filename }}
            </a>
        </div>
        <div class="message-header container-fluid">
            <div class="row">
                <div class="col">
                    <span>{{ message.from.display_as }}</span>
                </div>
                <div class="col text-right">
                    <div class="message-meta">
                        <div style="display: inline-block; padding-right: 1rem; margin-right: 1rem; border-right: 1px solid rgba(255,255,255,.3);">
                            <span style="margin-right: 10px;" v-if="message.events.clicked > 0">
                                <span style="vertical-align: middle; margin-right: 3px;" class="material-icons">ads_click</span>{{ message.events.clicked }}
                                <ui-tooltip>Number of clicks on attachments / links in the message</ui-tooltip>
                            </span>
                            <span style="margin-right: 10px;" v-if="message.events.seen > 0">
                                <span style="vertical-align: middle; margin-right: 3px;" class="material-icons">visibility</span>{{ message.events.seen }}
                                <ui-tooltip>Number of times the message has been viewed</ui-tooltip>
                            </span>
                            <span v-if="message.events.delivered > 0" style="vertical-align: middle;" class="material-icons">
                                done_all
                                <ui-tooltip>Delivered</ui-tooltip>
                            </span>
                            <span v-else-if="message.events.sent > 0" style="vertical-align: middle;" class="material-icons">
                                check
                                <ui-tooltip>Sent</ui-tooltip>
                            </span>
                        </div>
                        <span v-if="message.medium === 'email'">
                            <span class="material-icons" style="vertical-align: middle;">alternate_email</span>
                            Email
                        </span>
                        <span v-else-if="message.medium === 'text'">
                            <span class="material-icons" style="vertical-align: middle;">phone_iphone</span>
                            Text
                        </span>
                        <span v-else>{{ message.medium }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {MessageBodyPartTypes} from "../../classes/Api/Inbox";

    export default {
        props: {
            message: {
                type: Object,
                required: true,
            },
            demoOutbound: {
                type: Boolean,
                default: false,
            }
        },
        mounted() {
            if (this.hasHtmlBody) {
                const frameDocument = this.$refs.htmlContent.contentWindow.document;
                let str = this.htmlBody

                if (str.indexOf('<html>') === -1) {
                    str = "<!doctype html><html><head><style>.dealerkit-ui-hidden { display: none !important; } html, body { margin: 0; padding: 0; font-weight: 400; line-height: 1.5; color: #212529; font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\"; a,abbr,acronym,address,applet,article,aside,audio,b,big,blockquote,body,canvas,caption,center,cite,code,dd,del,details,dfn,div,dl,dt,em,embed,fieldset,figcaption,figure,footer,form,h1,h2,h3,h4,h5,h6,header,hgroup,html,i,iframe,img,ins,kbd,label,legend,li,mark,menu,nav,object,ol,output,p,pre,q,ruby,s,samp,section,small,span,strike,strong,sub,summary,sup,table,tbody,td,tfoot,th,thead,time,tr,tt,u,ul,var,video{margin:0;padding:0;border:0;font:inherit;vertical-align:baseline}article,aside,details,figcaption,figure,footer,header,hgroup,menu,nav,section{display:block}body{line-height:1}ol,ul{list-style:none}blockquote,q{quotes:none}blockquote:after,blockquote:before,q:after,q:before{content:'';content:none}table{border-collapse:collapse;border-spacing:0} }</style></head><body><div>" + str + "</div></body></html>"
                }

                frameDocument.open();
                frameDocument.write(str);
                frameDocument.close();

                this.checkMessageFrameHeight()
            } else {
                this.contentLoading = false
            }
        },
        data() {
            return {
                height: 10,
                contentLoading: true,
                resizeCheckInterval: undefined,
            }
        },
        methods: {
            checkMessageFrameHeight() {

                this.contentLoading = false

                this.resizeCheckInterval = setInterval(function() {
                    if (this.$refs.htmlContent) {
                        const frameDocument = this.$refs.htmlContent.contentWindow.document;

                        this.height = Math.max(
                            frameDocument.querySelector('body').scrollHeight,
                            frameDocument.querySelector('body').offsetHeight,
                            frameDocument.documentElement.clientHeight,
                            frameDocument.documentElement.scrollHeight,
                            frameDocument.documentElement.offsetHeight
                        )

                        if (this.resizeCheckInterval && frameDocument.readyState === 'complete') {
                            clearInterval(this.resizeCheckInterval)
                            console.debug('stopping polling for document changes')
                        }
                    }
                }.bind(this), 250)
            }
        },
        computed: {
            hasHtmlBody() {
                return !!this.htmlBody
            },
            htmlBody() {
                let parts = this.message.body_parts.filter(p => p.type === MessageBodyPartTypes.TYPE_HTML)

                let content = false

                if (parts.length === 1) {
                    const removeLinkTargets = /(<a [^>]*)(target="[^"]*")([^>]*>)/gi
                    const addBlankLinkTargets = /<(a)([^>]+)>/gi
                   content = parts[0].content.replace(removeLinkTargets, '$1$3').replace(addBlankLinkTargets, '<$1 target="_blank"$2>')
                }

                return content
            },
            plainBody() {
                let parts = this.message.body_parts.filter(p => p.type === MessageBodyPartTypes.TYPE_PLAIN)

                return parts.length === 1 ? parts[0].content : false
            },
            isOutbound() {
                return this.message.to.type === 'contact'
            },
            hasAttachments() {
                return this.message.attachments.length > 0
            },
            messageClasses() {
                let classes = ['inbox-message', 'inbox-' + this.message.medium]

                if (this.isOutbound) {
                    classes.push('message-outbound')
                } else {
                    classes.push('message-inbound')
                }

                if (this.hasAttachments) {
                    classes.push('has-message-attachments')
                }


                return classes
            }
        }
    }
</script>

<style lang="scss">
    @import 'message-styles';
</style>